import React from 'react'
import type { ImageProps } from '@ztechapps/webui.util'
import { Image } from '@ztechapps/webui.util'

export const ProductThumbImage = ({ url, coverImageThumb, ...props }: { coverImageThumb?: string } & ImageProps) => {
  const finalUrl = coverImageThumb || url

  return <Image url={finalUrl} {...props} />
}
